import specialites from "json/specialites"

export  default specialites
